import { createSlice } from "@reduxjs/toolkit"

export const commonSlice = createSlice({
    name: "common",
    initialState: {
        Profile: {},
        recruiterIdAdmin: null,
        recruiterStatus: null,
        externalRecruiter: null,
    },
    reducers: {
        ProfileDetails: (state, { payload }) => {
            state.Profile = payload || state.Profile
        },
        OnLogout: (state, { payload }) => {
            state.Profile = {}
            state.token = ""
        },
        updateRecruiterIdAdmin: (state, { payload }) => {
            state.recruiterIdAdmin = payload;
        },
        updateRecruiterStatus: (state, { payload }) => {
            state.recruiterStatus = payload;
        },
        updateExternalRecruiter: (state, { payload }) => {
            state.externalRecruiter = payload;
        },
    }
})

export const { ProfileDetails, OnLogout, updateRecruiterIdAdmin, updateRecruiterStatus, updateExternalRecruiter } = commonSlice.actions